<template>
  <!--  el-scrollbar 滚动条美化-->
  <el-scrollbar :height="browserHeight" ref="scrollbarRef" class="page-component__scroll">

    <!--    头部-->
    <app-head @loadModule="loadModule"/>
    <!--    内容-->
    <app-body :module="module" ref="refCid"/>
    <!--    底部-->
    <app-foot/>

    <!--    回到顶部-->
    <el-backtop :bottom="50" :visibility-height="50" target=".page-component__scroll .el-scrollbar__wrap"></el-backtop>

    <!--    联系我们-小图标-->
    <div class="consult">
      <div>
        <div>
          <img src="@/assets/images/index/phone.svg"/>
          {{ company.fixPhone }}
        </div>

        <div @click="contactUsShow">
          <img src="@/assets/images/index/kf2.svg"/>
          联系我们
        </div>

        <div @click="contactUsShow">
          <img src="@/assets/images/index/bzzx.svg"/>
          帮助中心
        </div>
      </div>

      <img src="@/assets/images/index/kf.svg">
    </div>

    <!--    联系我们-->
    <contact-us v-show="this.$store.state.contactUsShow"/>
  </el-scrollbar>
</template>

<script>
import {AppHead, AppBody, AppFoot} from '@/layout/components'
import ContactUs from '@/components/ContactUs'
import {ref} from "vue"
import {company} from '@/global/constant'
import {useStore} from 'vuex'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  components: {
    AppHead,
    AppBody,
    AppFoot,
    ContactUs
  },
  setup() {
    const browserHeight = document.documentElement.clientHeight + 'px'

    const refCid = ref()

    let module = ref(null)

    const loadModule = (e) => {
      module.value = e
      refCid.value.loadModule(e)
      setScrollTop(0)
    }

    const scrollbarRef = ref()
    const setScrollTop = (e) => {
      scrollbarRef.value.setScrollTop(e)
    }

    const store = useStore()
    const contactUsShow = (e) => {
      store.commit('updateContactUsShow', e)
    }

    return {
      browserHeight,
      module,
      loadModule,
      refCid,
      scrollbarRef,
      setScrollTop,
      company,
      contactUsShow
    }
  }
}
</script>

<style scoped>
.consult {
  width: 128px;
  height: 128px;
  z-index: 998;
  position: fixed;
  bottom: 80px;
  right: 0;
}

.consult:hover > div {
  display: block;
}

.consult > div {
  position: absolute;
  top: -35px;
  right: 100px;
  width: 136px;
  background-color: #ffffff;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #D2D5DB;
  box-shadow: 0 17px 44px 0 rgba(4, 41, 142, 0.10);
  display: none;
}

.consult > div > div {
  padding: 10px 0 10px;
  cursor: pointer;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #000000;
}

.consult > div > div:nth-child(1) {
  color: #3470FF;
}

.consult > div > div > img {
  position: relative;
  top: 5px;
}
</style>
